import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { RcFile } from 'antd/es/upload';

import './index.less';

import IbButton from '../../common/IbButton';
import IbPopover from '../../common/IbPopover';
import AddResourceForm from '../AddResourceForm';
import IbIcon from '../../common/IbIcon';
import { AgentResourceModel } from '../../../../gamma-api';
import FileUpload from '../../common/FileUpload';
import IbTooltip from '../../common/IbTooltip';

const MAIN_CLASS_NAME = 'message-input-additional-controls';
const BUTTONS_CLASS_NAME = `${MAIN_CLASS_NAME}__buttons`;

export interface IMessageInputAdditionalControlsProps {
  onResourceAdd?: (resource: AgentResourceModel) => void;
  onAttachmentsUpload?: (files: RcFile[]) => void;
}

const MessageInputAdditionalControls: React.FC<IMessageInputAdditionalControlsProps> = ({
  onResourceAdd,
  onAttachmentsUpload,
}) => {
  const { t } = useTranslation();

  const [addResourcePopoverVisible, setAddResourcePopoverVisible] = useState(false);

  const onResourceAddClick = () => setAddResourcePopoverVisible(true);

  const onAddResourcePopoverVisibleChange = (visible?: boolean) => setAddResourcePopoverVisible(visible || false);

  const onAddResourceFormAdd = (resource: AgentResourceModel) => {
    onResourceAdd?.(resource);
    setAddResourcePopoverVisible(false);
  };

  const onFileUpload = async (files: RcFile[]) => {
    onAttachmentsUpload && onAttachmentsUpload(files);
    return false;
  };

  return (
    <div className={MAIN_CLASS_NAME}>
      <div className={BUTTONS_CLASS_NAME}>
        <FileUpload multiple noButton disabled={false} onUpload={onFileUpload}>
          <IbTooltip title={t('Chat: Controls: Attach: File: Tooltip')}>
            <IbButton icon={<IbIcon iconName="paperclip" size={20} />} type="icon" />
          </IbTooltip>
        </FileUpload>
        <IbPopover
          content={<AddResourceForm visible={addResourcePopoverVisible} onAdd={onAddResourceFormAdd} />}
          placement="leftTop"
          trigger={['click']}
          visible={addResourcePopoverVisible}
          onVisibleChange={onAddResourcePopoverVisibleChange}
        >
          <IbTooltip title={t('Chat: Controls: Add: Resource: Tooltip')}>
            <IbButton icon={<IbIcon iconName="doc-add" />} type="icon" onClick={onResourceAddClick} />
          </IbTooltip>
        </IbPopover>
      </div>
    </div>
  );
};

export default MessageInputAdditionalControls;
